import { render, staticRenderFns } from "./comparator-field.vue?vue&type=template&id=a87a17d4"
import script from "./comparator-field.vue?vue&type=script&lang=js"
export * from "./comparator-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports